import { Injectable } from '@angular/core';
import { FiBackendService } from '../../fi-backend/fi-backend.service';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import {
    IChecklistV2,
    IChecklistV2TemplateForList,
    IChecklistV2Viewer,
    ILightWeightChecklistV2,
} from '@fi-shared/checklist/checklist-v2';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Injectable()
export class FiChecklist2TemplateService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getChecklistTemplatesListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IChecklistV2TemplateForList>>(
            'Checklist/Checklist2Template/GetChecklistTemplatesListData',
            parameter,
        );
    }

    getChecklistTemplate(checklistTemplateId: number, auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetChecklistTemplate/${checklistTemplateId}?auditMode=${!!auditMode}`;
        return this.fiBackend.fetchData<IChecklistV2>(url);
    }

    getChecklistFromTemplate(checklistTemplateId: number, auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetChecklistFromTemplate/${checklistTemplateId}?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklistV2>(url));
    }

    getTemplateFromChecklist(checklistId: number, auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetTemplateFromChecklist/${checklistId}?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklistV2>(url));
    }

    getLightweightChecklistTemplates(auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetLightWeightChecklistTemplates?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<INameIdObj[]>(url));
    }

    saveChecklistTemplate(checklistTemplateForSave: IChecklistV2, auditMode: boolean) {
        const url = `Checklist/Checklist2Template/SaveChecklistTemplate?auditMode=${!!auditMode}`;
        return this.fiBackend.fetchDataPost<number>(url, checklistTemplateForSave);
    }

    deleteChecklistTemplates(checklistTemplateIds: number[], auditMode: boolean) {
        const url = `Checklist/Checklist2Template/DeleteChecklistTemplates?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<void>(url, checklistTemplateIds));
    }

    getChecklistViewerByChecklistTemplate(checklistTemplateId: number, auditMode: boolean) {
        let url = `Checklist/Checklist2Template/GetChecklistViewerByChecklistTemplate/${checklistTemplateId}?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklistV2Viewer>(url));
    }

    getChecklistTemplateSamples(auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetChecklistTemplateSamples?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<ILightWeightChecklistV2[]>(url));
    }

    getChecklistTemplateFromSample(checklistTemplateSampleId: number, auditMode: boolean) {
        const url = `Checklist/Checklist2Template/GetChecklistTemplateFromSample/${checklistTemplateSampleId}?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklistV2>(url));
    }
}
